var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9812 17.1827C6.14664 17.1827 2.01807 17.9137 2.01807 20.8411C2.01807 23.7685 6.12045 24.5256 10.9812 24.5256C15.8157 24.5256 19.9431 23.7935 19.9431 20.8673C19.9431 17.9411 15.8419 17.1827 10.9812 17.1827Z",
    stroke: "#303030",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9811 13.0074C14.1537 13.0074 16.7252 10.4347 16.7252 7.26211C16.7252 4.0895 14.1537 1.51807 10.9811 1.51807C7.80849 1.51807 5.23587 4.0895 5.23587 7.26211C5.22516 10.424 7.77992 12.9966 10.9406 13.0074H10.9811Z",
    stroke: "#303030",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.a6ead578a46369c3ed89f54948132d56.svg";
export { ForwardRef as ReactComponent };